module.exports = __webpack_public_path__ + "img/app-store.bb95c469.png";